export const DEFAULT_SUBSCRIPTION_TYPE = 'monthly';

export const SUBSCRIPTION_TYPES = [
  { value: 'monthly', label: 'Monthly', months: 1, days: 30 },
  { value: 'quarterly', label: 'Quarterly', months: 3, days: 90 },
  { value: 'half_yearly', label: 'Half Yearly', months: 6, days: 180 },
  { value: 'yearly', label: 'Yearly', months: 12, days: 365 },
];

export const SUBSCRIPTION_TYPE_VALUES = SUBSCRIPTION_TYPES.map(type => type.value);

const ALIASES = {
  monthly: 'monthly',
  month: 'monthly',
  m: 'monthly',
  '1': 'monthly',
  one_month: 'monthly',
  quarterly: 'quarterly',
  quarter: 'quarterly',
  q: 'quarterly',
  '3': 'quarterly',
  three_month: 'quarterly',
  three_monthly: 'quarterly',
  half: 'half_yearly',
  half_year: 'half_yearly',
  halfyear: 'half_yearly',
  half_yearly: 'half_yearly',
  halfyearly: 'half_yearly',
  '6': 'half_yearly',
  six_month: 'half_yearly',
  six_monthly: 'half_yearly',
  h: 'half_yearly',
  yearly: 'yearly',
  year: 'yearly',
  annual: 'yearly',
  annually: 'yearly',
  y: 'yearly',
  '12': 'yearly',
  twelve_month: 'yearly',
};

export function normalizeSubscriptionType(raw) {
  if (raw === null || raw === undefined) return DEFAULT_SUBSCRIPTION_TYPE;
  const key = String(raw).trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (ALIASES[key]) return ALIASES[key];
  const flat = String(raw).trim().toLowerCase().replace(/[\s_-]+/g, '');
  return ALIASES[flat] || DEFAULT_SUBSCRIPTION_TYPE;
}

export function isSameSubscriptionType(a, b) {
  return normalizeSubscriptionType(a) === normalizeSubscriptionType(b);
}

export function getSubscriptionType(raw) {
  const value = normalizeSubscriptionType(raw);
  return SUBSCRIPTION_TYPES.find(type => type.value === value) || SUBSCRIPTION_TYPES[0];
}

export function subscriptionTypeLabel(raw) {
  if (raw === null || raw === undefined || String(raw).trim() === '') return '-';
  return getSubscriptionType(raw).label;
}

export function subscriptionTypeDays(raw) {
  return getSubscriptionType(raw).days;
}

export function subscriptionTypeMonths(raw) {
  return getSubscriptionType(raw).months;
}

export function subscriptionTypeOptions(allLabel) {
  const options = SUBSCRIPTION_TYPES.map(type => ({ value: type.value, label: type.label }));
  return allLabel ? [{ value: 'all', label: allLabel }, ...options] : options;
}
